import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./registerServiceWorker";
import ArgonDashboard from "./plugins/argon-dashboard";
import moment from "moment";
import VueGtag from "vue-gtag";

Vue.config.productionTip = false;

Vue.use(ArgonDashboard);
Vue.prototype.moment = moment;
Vue.mixin({
  methods: {
    formatDate(rawDate, format = "ll") {
      return this.moment(rawDate, "YYYY-MM-DD").locale("pt-br").format(format);
    },
    getYear(input) {
      const date = this.moment(input);
      return date.isValid() ? date.year() : "...";
    },
    formatTimestamp(timestamp, format = "LLL") {
      return this.moment(timestamp, "YYYY-MM-DD hh:mm:ss")
        .locale("pt-br")
        .format(format);
    },
    formatValue(value, allowNegative = false) {
      const valueNumber = Number(value);
      if (valueNumber > 0 || allowNegative) {
        return valueNumber.toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL",
        });
      }
      return "-";
    },
  },
});

// Configuration VueGtag
Vue.use(
  VueGtag,
  {
    config: { id: "UA-146743116-2" },
    appName: "Portal Stars",
    pageTrackerScreenviewEnabled: true,
  },
  router
);

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
